import { Capacitor, registerPlugin } from "@capacitor/core";

const SecureLibrary = registerPlugin("SecureLibrary");

export const isSecureOfflineLibraryAvailable = () => Capacitor.isNativePlatform();

export async function getSecureLibraryIdentity() {
  if (!isSecureOfflineLibraryAvailable()) return null;
  return SecureLibrary.identity();
}

export async function listSecureLibraryDownloads() {
  if (!isSecureOfflineLibraryAvailable()) return [];
  const response = await SecureLibrary.list();
  return Array.isArray(response?.items) ? response.items : [];
}

export async function downloadSecureLibraryItem({ item, url, authorization }) {
  if (!isSecureOfflineLibraryAvailable()) {
    throw new Error("La lecture hors ligne est disponible uniquement dans l'application MMJ.");
  }
  return SecureLibrary.download({
    productId: item.id,
    url,
    authorization,
    metadata: {
      product_id: item.id,
      title: item.title || "MMJ",
      author_name: item.author_name || "ARTICO",
      media_type: item.media_type || "bin",
      thumbnail_path: item.thumbnail_path || item.cover_image_path || "",
    },
  });
}

export async function readSecureLibraryItem(productId) {
  if (!isSecureOfflineLibraryAvailable()) return null;
  const response = await SecureLibrary.read({ productId });
  const binary = window.atob(response?.data || "");
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return { data: bytes.buffer, metadata: response?.metadata || {} };
}

export async function prepareSecureLibraryMedia(productId, mediaType) {
  if (!isSecureOfflineLibraryAvailable()) return null;
  const response = await SecureLibrary.prepareMedia({ productId, mediaType });
  return response?.path ? Capacitor.convertFileSrc(response.path) : null;
}

export async function clearSecureLibraryTemporaryMedia(productId) {
  if (!isSecureOfflineLibraryAvailable() || !productId) return;
  await SecureLibrary.clearTemporaryMedia({ productId });
}

export async function removeSecureLibraryItem(productId) {
  if (!isSecureOfflineLibraryAvailable()) return false;
  const response = await SecureLibrary.remove({ productId });
  return Boolean(response?.removed);
}
